module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-theAtlantic.e677bedd3e236707befe860fd6222307.png";